import { render, staticRenderFns } from "./JianShu.vue?vue&type=template&id=71a58591&scoped=true"
import script from "./JianShu.vue?vue&type=script&lang=js"
export * from "./JianShu.vue?vue&type=script&lang=js"
import style0 from "./JianShu.vue?vue&type=style&index=0&id=71a58591&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a58591",
  null
  
)

export default component.exports